import React, { Component } from 'react';
import PropTypes from 'prop-types';
import '../../../styles/scss/style.css';

//Components
import Icon from '../atoms/Icon';
import TextParagraph from '../atoms/TextParagraph';

//Returning the component
class AddCreditCard extends Component {
	render() {
		return (
			<div className="addCreditCard">
				<div className="addCreditCard__icon">
					<Icon classType="icon--button fa-3x fa-plus" role="button" />
				</div>
				<TextParagraph text="Add credit card" />
			</div>
		)
	}
}

AddCreditCard.propTypes = {
	creditCardIcon: PropTypes.string,
	company: PropTypes.string,
	number: PropTypes.string,
	date: PropTypes.string,
}

export default AddCreditCard;


// WEBPACK FOOTER //
// ./src/redux/components/organisms/AddCreditCard.jsx